<template>
  <div class="nav-icon-links">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <swiper :options="swiperOption">
        <swiper-slide
            class="block"
            v-for="(category, index) in categorys"
            :key="'icon' + index">
          <div class="nav-icon-img">
            <a v-bind:href="category.tc_url" target="_blank">
              <img :src="category.tc_pic" width="54px" height="54px" style="border-radius: 100%;" />
            </a>
          </div>
          <div class="nav-title">{{ category.tc_name }}</div>
        </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'navIconLinks',
  props: {
    cycle: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 7000,
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      categorys: [{
        tc_pic: '../../images/placholder_1200.svg',
        tc_name: '',
        tc_url: ''
      }],
      isLoading: true,
      swiperOption: {
        slidesPerView: 4.5,
        spaceBetween: 8,
        loop: false,
      },
    }
  },
  methods: {
    getData () {
      axios.get('/ticket/api/category/list')
      .then((response) => {
        this.categorys = response.data;
        this.isLoading = false;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin i5 {
  @media (max-width: 340px) {
    @content;
  }
}

.swiper-slide {
  text-align: center !important;
}

.swiper-container {
  margin-top: 20px !important;
}

.nav-icon-links {
  border-radius: 16px;
  .nav-title {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 60px;
    margin: 0 auto;
    color: #383838;
    font-weight: 500;
  }
}

</style>

